import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(event) {
    event.preventDefault(); // Prevent the default behavior of the link or button

    const btn = event.currentTarget
    // Read now: a parent action handling the same click overwrites `event.params`.
    const buttonText = event.params.buttonText
    const text = this.textToCopy(event)
    if (!text) return

    navigator.clipboard.writeText(text)
    .then(() => {
      btn.innerHTML = "<i class='far fa-check-circle'></i>"
      setTimeout(() => {
        btn.innerHTML = buttonText
      }, 2000);
    });
  }

  // `textToCopy` : valeur figée. `source` : sélecteur dans le plus proche `[data-copy-scope]`,
  // pour un contenu qui change (ID de template dans un exemple de payload).
  textToCopy(event) {
    const source = event.params.source
    if (source) {
      const scope = event.currentTarget.closest("[data-copy-scope]") || event.currentTarget.parentElement
      return scope?.querySelector(source)?.textContent ?? ""
    }

    return event.params.textToCopy ?? ""
  }
}
